import api from '@/js/services/api';

export default {
    getList(filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get('/master-admin/settings/preconfigured-responses/get?' + searchParams.toString())
    },

    getListWithDefaultFilters() {
        return api().get('/master-admin/settings/preconfigured-responses/get?status=all&search=&page=1&perPage=20')
    },
    filters: {
        search: '',
        status: 'all',
        page: 1,
        perPage: 20
    },
    saveNewItem(form) {
        return api().post(`/master-admin/settings/preconfigured-responses/create`, form)
    },

    updateItem(id, response) {
        return api().put(`/master-admin/settings/preconfigured-responses/${id}/update`, response )
    }
}
